import { defineMobileFormWindow } from "@app/overlay";
import { SearchObjectForm } from "./SearchObjectForm";

/**
 * Overlay-окна поиска СО (сканер из нижней навигации).
 *
 * Opener — `MobileNavBar` (shell, не page). Owner не размонтируется при смене
 * route, поэтому закрытие при «Меню» делает сам shell через `OverlayHandle`
 * (см. контракт в `MobileNavBar`), а не `close-on-owner-unmount`.
 */
export const searchObjectWindows = {
    main: defineMobileFormWindow({
        key: "app.searchObject",
        title: "Сканировать номер объекта",
        closeOnSubmit: true,
        reuse: "focus-existing",
        component: SearchObjectForm,
    }),
};
